import { type ReactNode, type SyntheticEvent, useRef, useState } from "react";
import { Box, type BoxProps, Skeleton } from "@mui/material";

interface ImageProps extends Omit<BoxProps<"img">, "component"> {
  loadingComponent?: ReactNode;
  errorComponent?: ReactNode;
  // fallbackURL?: string;
  alt: string;
  height: string | number;
  width: string | number;
}

type EventType = SyntheticEvent<HTMLImageElement, Event>;

export default function Image({ height, width, loadingComponent, errorComponent, onError, onLoad, ...rest }: ImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const eleRef = useRef<HTMLImageElement | null>(null);

  return (
    <Box sx={{ position: "relative", height: "100%", width: "100%", overflow: "hidden" }} role={"presentation"}>
      <Box
        sx={{ opacity: isLoading ? 0 : 1, visibility: !isError ? "visible" : "hidden" }}
        component={"img"}
        width={width}
        height={height}
        ref={eleRef}
        onLoad={(e: EventType) => {
          setIsLoading(false);
          setIsError(false);

          // notify the parent handler
          onLoad?.(e);
        }}
        onError={(e: EventType) => {
          setIsError(true);
          setIsLoading(false);

          // notify the parent error handler
          onError?.(e);
        }}
        aria-hidden={isLoading || isError}
        {...rest}
      />
      {isLoading &&
        !isError &&
        (loadingComponent || (
          <Box
            sx={{
              position: "absolute",
              height: height || "100%!important",
              width: width || "100%!important",
              inset: 0,
              zIndex: 99,
              bgcolor: "#1a2433"
            }}
          >
            <Skeleton
              variant='rectangular'
              sx={{
                height: "100%",
                width: "100%",
                bgcolor: "grey.400"
              }}
            />
          </Box>
        ))}

      {isError && errorComponent}
    </Box>
  );
}
